<div class="blocked-sdrs-container">
    <div class="title">Blocked SDRs</div>
    <div *ngFor="let blockedSdr of blockedSdrs">
        <div class="list">
            {{blockedSdr}}
        </div>
    </div>
</div>